<template>
  <div>
    <div class="modal_bg" @click="closeModal" v-if="needShow"></div>
    <div class="modal_body need_modal" v-if="needShow">
      <span class="iconfont icon-guanbi" @click="closeModal">&#xe612;</span>
      <h6 class="need_title">请留下您的需求，我们将在第一时间联系您</h6>
      <div class="neeed_content">
        <div class="input_bg rules" ref="inputName" :class="{' input_bg_selected':form.name != ''}">
          <input type="text" v-model="form.name" @focus="changeClass('Name')">
          <p class="input_placeholder">您的称呼</p>
        </div>
        <div class="input_bg rules" ref="inputphone" :class="{' input_bg_selected':form.phone != ''}">
          <input type="number" v-model="form.phone" @focus="changeClass('phone')">
          <p class="input_placeholder">联系方式</p>
        </div>
        <div class="input_bg" ref="inputCompany">
          <input type="text" v-model="form.company" @focus="changeClass('Company')">
          <p class="input_placeholder">您的公司/单位全称</p>
        </div>
        <div class="input_bg rules" ref="inputNeeds" :class="{' input_bg_selected':form.needs != ''}">
          <input type="text" v-model="form.needs" @focus="changeClass('Needs')">
          <p class="input_placeholder last_input_placeholder">您的需求</p>
        </div>
        <div class="submit_btn">
          <button @click="submit">提交需求</button>
          <span>* 项不可为空</span>
        </div>
      </div>
    </div>
    <SuccessModal ref="success"/>
  </div>
</template>

<script>
import SuccessModal from "@/components/Success";
import { submitXinyongInfo } from "@/api";
import "@/js/message";

export default {
  name: "UserNeed",
  components: {
    SuccessModal
  },
  data() {
    return {
      isloading: false,
      form: {
        name: "",
        phone: "",
        company: "",
        needs: "",
        type: 0
      },
      needShow: false,
      phoneNum: /^1[3|4|5|6|7|8|9][0-9]\d{4,8}$/,
      regs: /^[1-9]\d*\.\d*|0\.\d*[1-9]\d*$/,
      reg: /^[1-9]+[0-9]*]*$/,
      errorShow: true,
      message: '请输入您的姓名'
    }
  },
  methods: {
    submit() {
      if (this.isloading) return;
      this.isloading = true;
      if (!this.form.name || this.form.name.length < 2) {
        this.isloading = false;
        toast({ msg: '请填写正确的称呼!', type: 'warning', time: 3e3 });
        this.$refs.inputName.className += " input_bg_empty";
        return;
      }
      //   这个检验手机号码错误
      if (this.form.phone.length < 10 || !(this.phoneNum.test(this.form.phone))) {
        this.isloading = false;
        toast({ msg: '请填写正确的联系方式!', type: 'warning', time: 3e3 });
        this.$refs.inputphone.className += " input_bg_empty";
        return;
      }
      /*if(!this.form.company){
       this.$refs.inputCompany.className += " input_bg_empty";
       return;
       }*/
      if (!this.form.needs) {
        this.isloading = false;
        toast({ msg: '请输入您的需求!', type: 'warning', time: 3e3 });
        this.$refs.inputNeeds.className += " input_bg_empty";
        return;
      }

      let data = {
        name: this.form.name,
        phone: this.form.phone,
        type: this.form.type,
        needs: this.form.needs + "|",
        company: this.form.company,

      }
      submitXinyongInfo(data).then(res => {
        if (res.code === 1) {
          this.isloading = false
          this.closeModal();
          this.$refs.success.showModal();
          this.form.name = '';
          this.form.phone = '';
          this.form.type = 0;
          this.form.needs = '';
          this.form.company = '';
          setTimeout(() => {
            this.closeModal();
          }, 2e3);
        }
      })
    },

    showModal(title, id) {
      this.form.needs = title.replace("<br>", "");
      ;
      this.form.type = id;
      this.needShow = true;
    },
    closeModal() {
      this.needShow = false;
      this.$refs.success.hideModal();
    },
    changeClass(value) {
      this.$refs['input' + value].className.replace(" input_bg_empty", "");
    }
  }
};
</script>

<style scoped lang="less">
  .need_modal {
    background: #fff url("../assets/zhengxin_modal_img.jpg") 100% 100% no-repeat;
    background-size: 339px;
    border-radius: 4px;
    overflow: hidden;
    width: 640px;

    .need_title {
      font-size: 22px;
      color: #fff;
      padding: 30px;
      background: url("../assets/zhengxin_modal_bg.png") 0 0 no-repeat;
      background-size: cover;
    }

    .neeed_content {
      padding: 27px 0 27px 50px;
      width: 60%;
      box-sizing: border-box;

      .input_bg {
        position: relative;
        height: 56px;
        border-bottom: 1px solid #DFDFDF;

        &.rules::before {
          position: absolute;
          left: -10px;
          bottom: 5px;
          content: "*";
          color: #E30000;
          font-size: 14px;
        }

        .input_placeholder {
          position: absolute;
          left: 0;
          bottom: 5px;
          font-size: 16px;
          color: #86868B;
          transition: all .3s;
          z-index: 1;
        }

        input {
          position: absolute;
          left: 0;
          bottom: 0;
          display: block;
          width: 100%;
          height: 28px;
          line-height: 28px;
          font-size: 16px;
          z-index: 10;
        }

        input:focus + .input_placeholder {
          font-size: 12px;
          bottom: 30px;
        }
      }

      .input_bg_selected {
        .input_placeholder {
          font-size: 12px;
          bottom: 30px;
        }
      }

      .input_bg_empty {
        border-bottom-color: #e30000;

        .input_placeholder {
          color: #e30000;
        }
      }

      .submit_btn {
        margin-top: 36px;

        button {
          width: 110px;
          height: 38px;
          background: #005293;
          border-radius: 4px;
          text-align: center;
          line-height: 38px;
          font-size: 18px;
          color: #fff;
          cursor: pointer;
        }

        span {
          padding-left: 15px;
          font-size: 12px;
          color: #E30000;
        }
      }
    }
  }
</style>
